import { Injectable } from '@angular/core';
import { AppInitService } from 'src/app/app-init.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';import { UserGridRequestModel } from '../models/userGridRequestModel';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { IBasicUserSettingsModel } from '../models/basicSettingsModel';
import { IAdditionalSettingsModel } from '../models/accountAndLoginSettingsModel';
import { HomeLocation } from '../models/homeLocationsModel';
import { DayOfWeek } from '../models/day.enum';
import { PasswordResetRequestModel } from '../models/passwordResetRequestModel';
import { UserLobbySettingsModel } from '../models/lobbySettingsModel';
import { IUserAppointmentSettingsModel } from '../models/appointmentSettingsModel';
import { UserInfoDto } from '../models/userinfo.dto';
import { AvailabilityPostModel } from '../models/availabilitiyPostModel';
import { DisplayUser } from '../models/displayUserModel';
import { ProductCategoryCodesAndNames } from 'src/app/admin/product-services/shared/models/ProductCategoryCodesAndName';
import { UserServiceGridModel } from '../models/user-service-grid-model';
import { IUserServiceDataGrid } from '../models/user-service-data-grid';
import { UserSkillsGridModel } from '../models/userSkillsGridModel';
import { AvailabilityTemplate } from '../models/availabilityTemplate';
import { IListItemModel } from '../models/listItemModel';
import { MeetingPreference } from '../models/meetingPreference.enum';
import { WaitSmarterSettingsComponent } from 'src/app/admin/system-configuration/wait-smarter-settings/wait-smarter-settings.component';
import { UserPermissions } from 'src/app/shared/enums/permissionType'
import PopIoValidationResult from '../models/popIoValidationResultResponse';
import { UserEditDetails } from '../models/userEditDetailsModel';
import { type } from 'os';
import { Timezone } from 'src/app/master/models/timeZone';
import { TranslateService } from '@ngx-translate/core';
import { Store } from "@ngrx/store";
import { getLoggedInUserInfo } from "src/app/state";
import { State } from "src/app/state/app.state";
declare const window: any;
@Injectable({
  providedIn: 'root'
})

export class UserService {
  public editUser: UserEditDetails | null = null;
  public pageMode: string = '';
  public openStatus: boolean | null = null;
  public supervisorList: DisplayUser[] = [];
  public isSavingSuccessful: boolean | null = null;
  public conferencingProvider: string ='';
  private userPreferedTimeZone: Timezone | undefined;
  public availabilityTempLocationList: HomeLocation[] = [];
  public avialabilityTempGridDataSet: AvailabilityTemplate[] = [];
  public defaultItem: AvailabilityLocation = { id: 0, locationName: 'Use Home Location', level: 0 };
  public centeredMeetingPreferenceList: Array<IListItemModel> = [{ id: MeetingPreference.InPerson, displayValue: 'In-Person' }, { id: MeetingPreference.Phone, displayValue: 'Phone' }, { id: MeetingPreference.Virtual, displayValue: 'Virtual' }];
  private meetingPreferencesSubject = new BehaviorSubject({});
  public meetingPreferencData = this.meetingPreferencesSubject.asObservable();
  private preferredLanguageId : number = 1;

  public redirectUrl:string ='' ;
  private appConfig!: AppConfigurations;
  private adminServiceUserControllerUrl: string ='';
  private adminServiceLookupsControllerUrl: string ='';
  private adminServiceProductCategoryController: string ='';

  public confUserId: string | null = '';
  private isUnsaveChangesInAppointmentSettings: boolean | null = null;
  public useHomeLocationText: string = '';
  public useFloatLocationText: string = '';
  
  
  constructor(private appInitService: AppInitService, private http: HttpClient, private translateService: TranslateService, private store: Store<State>) {
    appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceiveAppConfig(config)
    });
  }

  private _onReceiveAppConfig(appConfig: AppConfigurations){
    this.appConfig = appConfig;
    this.redirectUrl = this.appConfig.authentication.redirectUri;
    this.adminServiceUserControllerUrl = `${this.appConfig.adminApi.baseApiUrl}${this.appConfig.adminApi.userController}`;
    this.adminServiceLookupsControllerUrl = `${this.appConfig.adminApi.baseApiUrl}${this.appConfig.adminApi.lookupsController}`
    this.adminServiceProductCategoryController = `${this.appConfig.adminApi.baseApiUrl}${this.appConfig.adminApi.productcategoryController}`
  }

  /**
   * Loads users data to the Users Grid
   * -1=All
   *  1=Active
   *  0=Inactive
   */
  public getUsersForTheGrid(userGridRequest: UserGridRequestModel): Observable<any> {
    const url = `${this.adminServiceUserControllerUrl}?status=${userGridRequest.Status}
    &locationId=${userGridRequest.LocationId}
    &includeSubLocations=${userGridRequest.IncludeSubLocations}
    &sortInfo.sortColumn=${userGridRequest.SortInfo.SortColumn}&sortInfo.sortDirection=${userGridRequest.SortInfo.sortDirection}
    &pageInfo.page=${userGridRequest.PageInfo.Page}
    &pageInfo.pageSize=${userGridRequest.PageInfo.PageSize}
    &searchText=${userGridRequest.SearchText}&userType=${userGridRequest.UserType}&requestFrom=${userGridRequest.RequestFrom}
    &permissionGroupId=${userGridRequest.PermissionGroupId}`;
    return this.http.get<any>(url);
  }

  public availabilityLocation(isFloat: boolean){
    this.translateService.get(['_User_Home_Float_Locations_Ts_Text_', '_User_Use_Float_Locations_Ts_Text_']).subscribe(res => {
      if (isFloat){
        this.defaultItem = { id: 0, locationName: res['_User_Use_Float_Locations_Ts_Text_'], level: 0 };
      }else{
        this.defaultItem = { id: 0, locationName: res['_User_Home_Float_Locations_Ts_Text_'], level: 0 };
      }
    });
  }

    getPreferredLanguage() {
    this.store.select(getLoggedInUserInfo).subscribe((user) => {
      if (user !== undefined && user !== null && user['preferredLanguage']) {
        this.preferredLanguageId = user['preferredLanguage'];
      }
    }
    );
  }

  private get languageParam(): HttpParams {
      return new HttpParams().set('preferredLanguageId', this.preferredLanguageId.toString());
  }

  /**
   * Return the client redirect url for password reset
   */
  public getReturnUrl(){
    return this.redirectUrl;
  }

  /**
   * Returns the editing user
   */
  public getEditingUser() {
    return this.editUser;
  }

  /**
   * Sets the edditing user
   * @param user - should be null when "user grid" or "user add"
   */
  
  public setEditingUser(user: UserEditDetails | null) {
    this.isUnsaveChangesInAppointmentSettings = false;
    this.editUser = user;
  }

  /**
   * Returns the editing user
   */
  public getOpenStatus() {
    return this.openStatus;
  }

  /**
   * Sets the edditing user
   * @param user
   */
  public setOpenStatus(openStatus: boolean) {
    this.openStatus = openStatus;
  }


  /**
   * Sets the user setting page mode (Add/Edit)
   * @param pageMode
   */
  public setPageMode(pageMode: string) {
    this.pageMode = pageMode;
  }

  /**
 * Gets the edditing user details
 * @param user
 */
  public getEditingUserDetails(userId: number): Observable<UserEditDetails> {
    this.getPreferredLanguage();
    const url = `${this.adminServiceUserControllerUrl}${userId}`;
    return this.http.get<UserEditDetails>(url, {params: this.languageParam});
  }

  /*
  * Get the homelocation lookups
  */
  public getLHomeLocations(locationTypeId=-1,includeInactive=false): Observable<HomeLocation[]> {
    const url = `${this.adminServiceLookupsControllerUrl}/homelocations/${locationTypeId}?includeInactive=${includeInactive}`;
    // const headersParams = new HttpHeaders().set('Authorization', pass);
    return this.http.get<HomeLocation[]>(url);
  }

  /**
   * Get specific users details
   * @param userId user id
   */
  public getUser(userId: number): Observable<UserEditDetails> {
    this.getPreferredLanguage();
    const url = `${this.adminServiceUserControllerUrl}${userId}`;
    return this.http.get<UserEditDetails>(url, {params: this.languageParam});
  }

  /**
   * Deactivates a selected User From the Main Grid
   */
  public deactivateUser(userId: number): Observable<any> {
    const url = `${this.adminServiceUserControllerUrl}${userId}`;
    return this.http.delete<any>(url);
  }

   /**
   * Activate a selected User From the Main Grid
   */
  public activateUser(userId: number): Observable<any> {
    const url = `${this.adminServiceUserControllerUrl}${userId}/activate`;
    return this.http.patch<any>(url, userId);
  }

  /**
 * Save basic user settings
 */
  public addUser(userSettings: IBasicUserSettingsModel): Observable<any> {
    const url = `${this.adminServiceUserControllerUrl}`
    return this.http.post<any>(url, userSettings);
  }

  /**
   * Add new user synchronously
   * @param userSettings user settings details
   */
  public addUserSynchronous(userSettings: IBasicUserSettingsModel): Observable<any> {
    const url = `${this.adminServiceUserControllerUrl}synchronous`
    return this.http.post<any>(url, userSettings);
  }

  /**
   * Update user basic settings
   * @param userSettings basic settings
   * @param userId user id
   */
  public updateBasicUserSettings(userSettings: IBasicUserSettingsModel, userId: number): Observable<any>{
    const url = `${this.adminServiceUserControllerUrl}basicSettings/${userId}`
    return this.http.put<any>(url, userSettings);
  }

  /**
   * Update user lobby settings
   * @param userLobbySettings lobby settings
   * @param userId user id
   */
  public updateLobbySettings(userLobbySettings: UserLobbySettingsModel, userId: number): Observable<any>{
    const url = `${this.adminServiceUserControllerUrl}lobbySettings/${userId}`
    return this.http.put<any>(url, userLobbySettings);
  }

  /**
   * Update user appointment settings
   * @param appointmentSettings appointment settings
   * @param userId user id
   */
  public updateAppointmentSettings(appointmentSettings: IUserAppointmentSettingsModel, userId: number): Observable<any>{
    const url = `${this.adminServiceUserControllerUrl}appointmentSettings/${userId}`
    return this.http.put<any>(url, appointmentSettings);
  }
  /**
   * * Get supervisors list
   * */
  public getSupervisors(): Observable<DisplayUser[]> {
    const url = `${this.adminServiceUserControllerUrl}supervisors/`;
    return this.http.get<DisplayUser[]>(url);
  }

  /**
   * Get all active product categories
   */
  public getProductCategoryDisplayData(): Observable<ProductCategoryCodesAndNames[]> {
    this.getPreferredLanguage();
    const url = `${this.adminServiceProductCategoryController}/sortorder`;
    return this.http.get<ProductCategoryCodesAndNames[]>(url, {params: this.languageParam});
  }

  /**
   * Check provided usernames availability
   * @param userId
   * @param userName
   */
  public checkUserNameExists(userId:number, userName: string): Observable<any>{
    const url = `${this.adminServiceUserControllerUrl}userNameExits/${userId}/${userName}`
    return this.http.get<any>(url);
  }

  /**
   * Check provided user codes availability
   * @param userId
   * @param userCode
   */
  public checkUserCodeExists(userId:number, userCode: string): Observable<any>{
    const url = `${this.adminServiceUserControllerUrl}userCodeExits/${userId}/${userCode}`
    return this.http.get<any>(url);
  }

  /**
   * Check provided user emails availability
   * @param userId
   * @param userEmail
   */
  public checkUserEmailExists(userId:number, userEmail: string): Observable<any>{
    const url = `${this.adminServiceUserControllerUrl}userEmailExits/${userId}/${userEmail}`
    return this.http.get<any>(url);
  }

  /**
  * Save Account and Login Settings
  */
  public saveAdditionalSettings(userSettings: IAdditionalSettingsModel): Observable<any> {

    // const url = `${this.baseUrl}${this.apiPath}/saveAccountSettings
    return Observable.create((observer: any) => {
      setTimeout(() => {
        observer.next(true);
      }, 1000);
    });
  }

  public saveAvailabilityTemplate(userAvailability : AvailabilityPostModel): Observable<any> {
    const url = `${this.adminServiceUserControllerUrl}availability/`;
    return this.http.put<any>(url, userAvailability);
  }

  public removeAvailabilityTemplate(rotationId : number): Observable<any> {
    const url = `${this.adminServiceUserControllerUrl}availabilityRemove/${rotationId}`;
    return this.http.put<any>(url, rotationId);
  }

  public getUserAvailabilityRotationByDateRange(numOfRotations : number, rotationNum : number, timeZone: string) : Observable<any> {
    const url = `${this.adminServiceUserControllerUrl}availability/rotationdaterange`;
    let queryParams = new HttpParams();
    queryParams = queryParams.set('numOfRotations', numOfRotations.toString());
    queryParams = queryParams.set('rotationNum', rotationNum.toString());
    queryParams = queryParams.set('timeZone', timeZone);
    return this.http.get<any>(url, { params: queryParams });
  }

  public setIsSaveSuccessful(success: boolean) {
    this.isSavingSuccessful = success;
  }

  public getIsSaveSuccessful() {
    return of(this.isSavingSuccessful);
  }
  /**
  * Sends the reset passowrd email.
  */
  sendResetPassowrdEmail(user: PasswordResetRequestModel): Observable<any> {
    const url = `${this.adminServiceUserControllerUrl}sendPasswordResetEmail`;
    return this.http.post<any>(url, user);
  }

  /**
  * Fill the availability template grid
  */
  getTimeSlotsForAvailabilityTemplate(): Observable<any> {
    return Observable.create((observer: any) => {
      setTimeout(() => {
        observer.next(dataForAvailabilityGrid);
      }, 1000);
    });
  }



  /**
  * Save the users skills inline changes
  */
  saveUserService(userServices: UserSkillsGridModel[]): Observable<any>{
    const url = `${this.adminServiceUserControllerUrl}skills`
    return this.http.put<any>(url, userServices);
  }

  /**
  * Save the users skills related changes
  */
  postServicesSkillsGrid(value: any): Observable<any> {
    const url = `${this.adminServiceUserControllerUrl}skills`
    return this.http.put<any>(url, value);
  }

  getLoggedInUserInfo(){ 
    const url = `${this.adminServiceUserControllerUrl}loggeduserinfo`;
    return this.http.get<UserInfoDto>(url);
  }

  getUserServices(userServiceGridParams : UserServiceGridModel) : Observable<IUserServiceDataGrid>
  {
    if(userServiceGridParams.sortInfo.sortDirection == null){
      throw Error("userServiceGridParams.sortInfo.sortDirection was null! Which was not expected!")
    }
    let queryParams = new HttpParams();
    queryParams = queryParams.set('serviceId', userServiceGridParams.serviceId.toString());
    queryParams = queryParams.set('optInStatus', userServiceGridParams.optInStatus.toString());
    queryParams = queryParams.set('pageInfo.page', userServiceGridParams.pageInfo.Page.toString());
    queryParams = queryParams.set('pageInfo.pageSize', userServiceGridParams.pageInfo.PageSize.toString());
    queryParams = queryParams.set('sortInfo.sortColumn', userServiceGridParams.sortInfo.SortColumn.toString());
    queryParams = queryParams.set('sortInfo.sortDirection', userServiceGridParams.sortInfo.sortDirection.toString());
    return this.http.get<IUserServiceDataGrid>(`${this.adminServiceUserControllerUrl}userservices`, {params : queryParams });
  }

  /**
   *
   * @returns Retrieve meeting preferences from external service.
   */
  getMeetingPreferences() : Observable<string>
  {
    const url =`${this.adminServiceLookupsControllerUrl}/meetingPreferences`;
    return this.http.get<string>(url);

  }

  /**
   *
   * @param preferences Set meeting preferences
   */
  setMeetingPreferences(preferences : any)
  {
    if(preferences)
    {
    this.meetingPreferencesSubject.next(preferences);
    }
  }

  /**
   * Retrieve virtual conferencing provider from external service.
   * @returns
   */
  getConferencingProvider() : Observable<string>
  {
    const url =`${this.adminServiceLookupsControllerUrl}/conferencingprovider`;
    return this.http.get<string>(url);
  }

  /**
   * Set virtual conferencing provider
   * @param provider
   */
  setConferencingProvider(provider : any){
    if (provider){
      this.conferencingProvider = provider;
    }
  }

  /**
   * Retrieve users virtual conferencing id from external service.
   * @returns
   */
  getConferencingUserId() : Observable<string>
  {
    var userName = this.editUser?.userDetails.userName;
    const url =`${this.adminServiceLookupsControllerUrl}/${userName}/conferencinguserid`;
    return this.http.get<string>(url);
  }

  /**
   * Retrieve users virtual conferencing provider status from external service.
   * @returns
   */
  getConferencingProviderAuthenticationStatus() : Observable<string>
  {
    var externalUserId = this.editUser?.userDetails.externalUserId;
    const url =`${this.adminServiceLookupsControllerUrl}/${externalUserId}/conferencingproviderauthenticationstatus`;
    return this.http.get<string>(url);
  }

  validatePopIoResourceExternalId(externalUserId: string, resourceExternalId: string): Observable<PopIoValidationResult>
  {
    const url = `${this.adminServiceLookupsControllerUrl}/popIO/externalUserId/${externalUserId}/resourceId/${resourceExternalId}`;
    return this.http.get<PopIoValidationResult>(url);
  }

  public getUsersByPermission(permissionId: UserPermissions): Observable<any> {
    const url = `${this.adminServiceUserControllerUrl}userByPermission/${permissionId}`;
    return this.http.get<any>(url);
  }

    public getUsersByLocation(locationId: number): Observable<any[]> {
    const url = `${this.adminServiceUserControllerUrl}byLocation/${locationId}`;
    return this.http.get<any[]>(url);
  }

  public getUsersByHomeLocation(): Observable<any> {
    const url = `${this.adminServiceUserControllerUrl}userListByHomeLocation`;
    return this.http.get<any>(url);
  }

  public setUserPreferedTimeZone(userPreferedTimeZone : Timezone) {
    this.userPreferedTimeZone = userPreferedTimeZone;
  }

  public getUserPreferedTimeZone(): Timezone{
    if(this.userPreferedTimeZone == undefined){
      throw Error("this.userPreferedTimeZone was undefined! Which was not expected!")
    } 
    return this.userPreferedTimeZone;
  }



  /**
   * Returns whether unsave changes In appointment settings
   */
   public checkUnsaveChangesInAppointmentSettings() {
    return this.isUnsaveChangesInAppointmentSettings;
  }

  /**
   * Sets whether unsave changes In appointment settings
   * @param isUnsaveChangesInAppointmentSettings
   */
  public setUnsaveChangesInAppointmentSettings(isUnsaveChangesInAppointmentSettings: boolean) {
    this.isUnsaveChangesInAppointmentSettings = isUnsaveChangesInAppointmentSettings;
  }


  public getJitUserNotifications(userId: number): Observable<any> {
    const url = `${this.adminServiceUserControllerUrl}jitusernotifications`
    return this.http.post<any>(url, userId);
  }

}

export const dataForAvailabilityGrid = [{
  "id": 1,
  "rotationDisplayValue": "Rotation 1",
  "rotation": [{
    "isAvailable": true,
    "dayOfWeek": DayOfWeek.Sunday,
    "startTime": [new Date()],
    "endTime": [new Date()],
    "userWorkLocation": [{ id: 1, displayValue: 'Home Location' }]
  },
  {
    "isAvailable": false,
    "dayOfWeek": DayOfWeek.Monday,
    "startTime": [new Date()],
    "endTime": [new Date()],
    "userWorkLocation": [{ id: 1, displayValue: 'Home Location' }]
  },
  {
    "isAvailable": true,
    "dayOfWeek": DayOfWeek.Tuesday,
    "startTime": [new Date(), new Date()],
    "endTime": [new Date(), new Date()],
    "userWorkLocation": [{ id: 1, displayValue: 'Home Location' }, { id: 2, displayValue: 'Some' }]
  },
  {
    "isAvailable": true,
    "dayOfWeek": DayOfWeek.Wednesday,
    "startTime": [new Date(), new Date()],
    "endTime": [new Date(), new Date()],
    "userWorkLocation": [{ id: 1, displayValue: 'Home Location' }, { id: 2, displayValue: 'Some' }]
  },
  {
    "isAvailable": true,
    "dayOfWeek": DayOfWeek.Thursday,
    "startTime": [new Date(), new Date()],
    "endTime": [new Date(), new Date()],
    "userWorkLocation": [{ id: 1, displayValue: 'Home Location' }, { id: 2, displayValue: 'Some' }]
  },
  {
    "isAvailable": true,
    "dayOfWeek": DayOfWeek.Friday,
    "startTime": [new Date(), new Date()],
    "endTime": [new Date(), new Date()],
    "userWorkLocation": [{ id: 1, displayValue: 'Home Location' }, { id: 2, displayValue: 'Some' }]
  },
  {
    "isAvailable": true,
    "dayOfWeek": DayOfWeek.Saturday,
    "startTime": [new Date(), new Date()],
    "endTime": [new Date(), new Date()],
    "userWorkLocation": [{ id: 1, displayValue: 'Home Location' }, { id: 2, displayValue: 'Some' }]

  }]
}
];

type AvailabilityLocation = {
  id: number, locationName: string, level: number
}
